/**
 * This base picker should be used to create any other for of picker.
 * The base handles custom styling to fit the wing-ui design system
 *
 * See documentation for all picker options: https://reactdatepicker.com/
 */
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import ReactDatePicker from 'react-datepicker';
import { makeStyles } from '../styles';
import { datePickerStyles } from '.';
const useStyles = makeStyles(({ palette, spacing }) => ({
    '@global': datePickerStyles,
    inputRoot: {
        color: palette.secondary.main,
    },
    calendar: {
        backgroundColor: palette.background.default,
    },
    day: {
        borderRadius: spacing(0.5),
    },
    selectedDay: {
        color: `${palette.secondary.contrastText} !imporant`,
        backgroundColor: palette.secondary.main,
        '&:hover': {
            backgroundColor: palette.secondary.dark,
        },
    },
}));
const DatePicker = forwardRef(({ customInput, selectedDate, ...rest }, ref) => {
    const classes = useStyles();
    const dayClassName = (date) => {
        const dateString = date.toDateString();
        const selectedDateString = selectedDate?.toDateString();
        const isSelected = dateString === selectedDateString;
        const isToday = dateString === new Date().toDateString();
        const dayClassNames = classNames(classes.day, {
            [classes.selectedDay]: isSelected,
        });
        return dayClassNames;
    };
    return (React.createElement(ReactDatePicker, { ref: ref, customInput: customInput, className: classes.inputRoot, calendarClassName: classes.calendar, fixedHeight: true, dayClassName: dayClassName, ...rest }));
});
export default DatePicker;
//# sourceMappingURL=DatePickerBase.js.map